import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import moment from 'moment';
import { CompactCard } from '../../../components';

const Headercards = ({
  cards,
  setMoreData,
  setCustomParams,
  setNameRangePicker,
  setDefaultStartDate,
  setDefaultEndDate
}) => {
  const [activeCard, setActiveCard] = useState('all');

  const handleClick = card => {
    switch (card) {
      case 'pending':
        setCustomParams({ status: 'pending' });
        setNameRangePicker('date_range');
        setActiveCard('pending');
        setDefaultStartDate(moment().subtract(2, 'months'));
        setDefaultEndDate(moment());
        setMoreData(v => !v);
        break;
      case 'rejected':
        setCustomParams({ status: 'rejected' });
        setNameRangePicker('date_range');
        setActiveCard('rejected');
        setDefaultStartDate(moment().subtract(2, 'months'));
        setDefaultEndDate(moment());
        setMoreData(v => !v);
        break;
      default:
        setCustomParams({});
        setNameRangePicker('date_range');
        setActiveCard('all');
        setDefaultStartDate(moment().subtract(2, 'months'));
        setDefaultEndDate(moment());
        setMoreData(v => !v);
        break;
    }
  };

  return (
    <>
      <Row className="mt-3 mb-3">
        <Col md={3} xs={12}>
          <CompactCard
            variant="info-grey"
            title={cards.all}
            label="Horas Extras Solicitadas"
            subtitle="Horas Extras Solicitadas"
            active={activeCard === 'all'}
            onClick={() => handleClick('all')}
          />
        </Col>
        <Col md={3} xs={12}>
          <CompactCard
            variant="warning"
            title={cards.pending}
            label="Horas Extras por Autorizar"
            subtitle="Horas Extras por Autorizar"
            active={activeCard === 'pending'}
            onClick={() => handleClick('pending')}
          />
        </Col>
        <Col md={3} xs={12}>
          <CompactCard
            variant="danger"
            title={cards.rejected}
            label="Horas Extras Rechazadas"
            subtitle="Horas Extras Rechazadas"
            active={activeCard === 'rejected'}
            onClick={() => handleClick('rejected')}
          />
        </Col>
      </Row>
    </>
  );
};

export default Headercards;

Headercards.propTypes = {
  cards: PropTypes.shape({
    pending: PropTypes.number.isRequired,
    all: PropTypes.number.isRequired,
    rejected: PropTypes.number.isRequired
  }),
  setMoreData: PropTypes.func,
  setCustomParams: PropTypes.func,
  setNameRangePicker: PropTypes.func,
  setDefaultStartDate: PropTypes.func,
  setDefaultEndDate: PropTypes.func
};

Headercards.defaultProps = {
  cards: {
    pending: 0,
    all: 0,
    rejected: 0
  },
  setMoreData: () => {},
  setCustomParams: () => {},
  setNameRangePicker: () => {},
  setDefaultStartDate: () => {},
  setDefaultEndDate: () => {}
};
